import { useEffect } from "react"

export const useKeyPressed = (key: string, onKeyPress: () => void, ref?: React.RefObject<HTMLElement>): void => {
  useEffect(() => {
    const handleKeyPress = (e: KeyboardEvent) => {
      if (e.key === key) {
        // If ref is provided, ensure the event target is within the ref
        if (!ref || ref?.current?.contains(e.target as Node)) {
          onKeyPress()
        }
      }
    }

    document.addEventListener("keydown", handleKeyPress)

    return () => {
      document.removeEventListener("keydown", handleKeyPress)
    }
  }, [key, onKeyPress, ref])
}

export default useKeyPressed
